import React from "react";
import { convertThenFormat } from "../../common-data/Converts";

const PlanDetailsMobile = ({ tableData, setModValues }) => {
  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {row?.type || "NA"}
                  </h3>

                  <span
                    className={`lead-type`}
                    style={{
                      background: "#E2EFD5",
                      color: "#379C00",
                    }}
                  >
                    {row?.coupon || "-"}
                  </span>
                </div>

                <div
                  className="card-other-info"
                  style={{ padding: "0 20px 20px 20px" }}
                >
                  <span className="value semi-bold">
                    price: <b>₹{convertThenFormat(row?.price || 0)}</b>
                  </span>

                  <span className="value semi-bold">
                    tax amount:{" "}
                    <b>
                      {" "}
                      ₹{convertThenFormat(row?.tax_amount || 0)} (
                      {row?.tax_percentage || 0})%
                    </b>
                  </span>

                  <span className="value semi-bold">
                    plan duration:{" "}
                    <b>
                      {" "}
                      {row?.start_date ? row.start_date : "-"} TO{" "}
                      {row?.expire_date ? row.expire_date : "-"}
                    </b>
                  </span>

                  <span className="value semi-bold">
                    lead source:{" "}
                    <b>{row?.lead_source?.replace(/_/g, " ") || "NA"}</b>
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <div className="all-btns lead-btn-axceed">
                    <div className="lead-log-box">
                      <button
                        className="lead-log view-lead"
                        onClick={() => {
                          row?.receptionist_data &&
                            setModValues((prevs) => ({
                              ...prevs,
                              isModOpen2: true,
                              cardName2: "agent_info",
                              rowData2: row?.receptionist_data || [],
                            }));
                        }}
                        style={{
                          opacity: row?.receptionist_data ? "1" : "0.5",
                          cursor: row?.receptionist_data
                            ? "pointer"
                            : "not-allowed",
                        }}
                        disabled={!row?.receptionist_data}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-view-list"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                        </svg>
                      </button>

                      <span className="btn-label">agent info</span>
                    </div>

                    <div className="lead-log-box">
                      <button
                        className="lead-log view-lead"
                        onClick={() => {
                          row?.is_partial &&
                            setModValues((prevs) => ({
                              ...prevs,
                              isModOpen2: true,
                              cardName2: "partial_details",
                              rowData2: row?.partial_details || [],
                            }));
                        }}
                        style={{
                          opacity: row?.is_partial ? "1" : "0.5",
                          cursor: row?.is_partial ? "pointer" : "not-allowed",
                        }}
                        disabled={!row?.is_partial}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-view-list"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                        </svg>
                      </button>

                      <span className="btn-label">partial detail</span>
                    </div>

                    <div className="lead-log-box">
                      <button
                        className="lead-log view-lead"
                        onClick={() => {
                          row?.package_data &&
                            setModValues((prevs) => ({
                              ...prevs,
                              isModOpen2: true,
                              cardName2: "package_data",
                              rowData2: [row?.package_data] || [],
                            }));
                        }}
                        style={{
                          opacity: row?.package_data ? "1" : "0.5",
                          cursor: row?.package_data ? "pointer" : "not-allowed",
                        }}
                        disabled={!row?.package_data}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-view-list"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                        </svg>
                      </button>

                      <span className="btn-label">package data</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PlanDetailsMobile;
